import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CatalogOperationsLayout } from '~/features/catalog-operations/components/catalog-operations-layout';
import { DeliveryWizardPage } from '~/features/catalog-operations/components/delivery-wizard/delivery-wizard-page';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';
import { requireFeatureGate } from '~/utils/guards';

// `redeliver` = the delivery run a Retry delivery started from; absent = first-time approval.
const searchSchema = z.object({
  redeliver: z.string().min(1).optional().catch(undefined),
});

export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-operations/$batchId_/deliver',
)({
  beforeLoad: requireFeatureGate('delivery-wizard'),
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { batchId } = Route.useParams();
  const { redeliver } = Route.useSearch();
  return (
    <CatalogOperationsLayout testId="delivery-wizard-layout">
      <RequireChannelConnection>
        {/* Keyed by mode so switching approval ↔ redelivery starts the wizard fresh. */}
        <DeliveryWizardPage
          key={redeliver ?? 'approve'}
          batchId={batchId}
          redeliverRunId={redeliver}
        />
      </RequireChannelConnection>
    </CatalogOperationsLayout>
  );
}
